import React from "react";
import NoticeBoardsContent from "./NoticeBoardsContent";

function index() {
	return <NoticeBoardsContent />;
}

export default index;
